var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white partner-dashboard"},[(_vm.isPartnerAuthenticated && !_vm.hideAppContainer)?_c('app-container'):_c('transition',{attrs:{"name":"route","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }